import { PipelineToolbar } from './toolbar';
import { PipelineUI } from './ui';
import { SubmitButton } from './submit';

function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: '#f5f7fa' }}>
      {/* Toolbar */}
      <div style={{ flex: '0 0 auto' }}>
        <PipelineToolbar />
      </div>

      {/* Main Canvas */}
      <div style={{ flex: '1 1 auto', minHeight: 0, overflow: 'hidden' }}>
        <PipelineUI />
      </div>

      {/* Submit Button Area */}
      <div style={{ 
        flex: '0 0 auto', 
        padding: '16px',
        backgroundColor: '#fff',
        borderTop: '1px solid #e1e8ed',
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.04)'
      }}>
        <SubmitButton />
      </div>
    </div>
  );
}

export default App;
